import { useState, useEffect } from "react";
import { fetchProfileCached } from "../../utils/cacheService";
import styles from "./DirectStories.module.css";

import perfilEspionado from "../../assets/direct/perfil-sem-foto.jpeg";
import avatar1 from "../../assets/direct/av-fallback-1.jpg";
import avatar2 from "../../assets/direct/av-fallback-2.jpg";
import avatar3 from "../../assets/direct/av-fallback-3.jpg";
import avatar4 from "../../assets/direct/av-fallback-4.jpg";
import avatar5 from "../../assets/direct/av-fallback-5.jpg";
import avatar6 from "../../assets/direct/av-fallback-6.jpg";
import avatar7 from "../../assets/direct/av-fallback-7.jpg";
import avatar8 from "../../assets/direct/av-fallback-8.jpg";
import avatar9 from "../../assets/direct/av-fallback-9.jpg";
import swing from "../../assets/direct/StorySwing.png";
import playboy from "../../assets/direct/playboy.jpg";

/* ===============================
   NOTA DE MÚSICA
   =============================== */

const MusicNote = ({ music }) => {
  const isShortTitle = music.title === "APT.";

  return (
    <div className={styles.musicNoteContent}>
      <div className={styles.musicHeader}>
        <div className={styles.musicIcon}>
          <svg viewBox="0 0 24 30" width="8" height="10">
            <rect height="19" rx="2" width="4" y="5" />
            <rect height="21" rx="2" width="4" x="10" y="4" />
            <rect height="19" rx="2" width="4" x="20" y="5" />
          </svg>
        </div>

        {isShortTitle ? (
          <span className={styles.musicTitle}>APT.</span>
        ) : (
          <div className={styles.musicTitleContainer}>
            <span className={`${styles.musicTitle} ${styles.scrolling}`}>
              {music.title}
              <span className={styles.musicGap}>{music.title}</span>
            </span>
          </div>
        )}
      </div>

      <span className={styles.musicArtist}>{music.artist}</span>
    </div>
  );
};

/* ===============================
   STORIES DATA
   =============================== */

const MOCK_STORIES = [
  {
    name: "Ped*******",
    note: "Preguiça Hoje 🥱🥱",
    avatar: avatar1
  },
  {
    name: "Lor*******",
    isMusicNote: true,
    music: {
      title: "Coração Partido (Ao Vivo)",
      artist: "Grupo Menos É Mais"
    },
    avatar: avatar2
  },
  {
    name: "Swi*******",
    note: "O vontde de 😈",
    avatar: swing
  },
  {
    name: "Enz*******",
    note: "25/01❤️",
    avatar: avatar3
  },
  {
    name: "Lau*******",
    note: "Alguém??",
    avatar: avatar4
  },
  {
    name: "Joã*******",
    isMusicNote: true,
    music: {
      title: "365 Dias (Vida Mansa)",
      artist: "MC Marks, MC Ryan SP, MC Jvila, MC Bruno MS, MC Magal"
    },
    avatar: avatar5
  },
  {
    name: "The*******",
    note: "Já não aguento mais!",
    avatar: avatar6
  },
  {
    name: "Bea*******",
    isMusicNote: true,
    music: {
      title: "APT.",
      artist: "Rosé & Bruno Mars"
    },
    avatar: avatar7
  },
  {
    name: "Sop*******",
    isMusicNote: true,
    music: {
      title: "Whats I've Done",
      artist: "Link Park"
    },
    avatar: avatar8
  },
  {
    name: "Let*******",
    isMusicNote: true,
    music: {
      title: "Oh Garota Eu Quero Você Só Pra Mim",
      artist: "Oruam, Zé Felipe, MC Tuto, MC Rodrigo Do CN"
    },
    avatar: avatar9
  },
  {
    name: "Marc*******",
    note: "📍💦",
    avatar: playboy
  }
];

const MOCK_NOTES = [
  "Preguiça Hoje 🥱🥱",
  "O vontde de 😈",
  "25/01❤️",
  "Alguém??",
  "Já não aguento mais!",
  "📍💦",
  "Boa noite 🌙",
  "Quem tá on?",
  "😍😍",
  "🔥"
];

// Mascara username (ex: "cristiano" -> "cri*******")
function maskUsername(username) {
  if (!username || username.length <= 3) return username || "Us*******";
  return username.substring(0, 3) + '*******';
}

export default function DirectStories() {
  const [stories, setStories] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  
  const profile = JSON.parse(localStorage.getItem('current_profile') || '{}');

  // Buscar seguidores reais para stories
  useEffect(() => {
    const ownStory = {
      name: "Sua nota",
      note: "Conte as novidades",
      avatar: profile.profileImageUrl || perfilEspionado,
      isOwnStory: true
    };

    async function fetchFollowersForStories() {
      try {
        const currentUsername = localStorage.getItem('current_username');
        if (!currentUsername) {
          setStories([ownStory, ...MOCK_STORIES]);
          setIsLoading(false);
          return;
        }

        const result = await fetchProfileCached(currentUsername);
        const { success, data } = result || {};
        
        if (success && data && data.followers && data.followers.length > 0) {
          // Converter seguidores em stories com notas
          const realStories = data.followers.slice(0, 11).map((follower, index) => ({
            name: maskUsername(follower.username),
            note: MOCK_NOTES[index % MOCK_NOTES.length],
            avatar: follower.profile_pic_url,
            isReal: true
          }));

          setStories([ownStory, ...realStories]);
          console.log('✅ Stories Direct reais carregados:', realStories.length);
        } else {
          setStories([ownStory, ...MOCK_STORIES]);
        }
      } catch (error) {
        console.error('❌ Erro ao buscar stories Direct:', error);
        setStories([ownStory, ...MOCK_STORIES]);
      } finally {
        setIsLoading(false);
      }
    }

    fetchFollowersForStories();
  }, [profile.profileImageUrl]);

  return (
    <div className={styles.directStories}>
      <div className={styles.storiesWrapper}>
        <div className={styles.storiesScroll}>
          {isLoading && (
            <div style={{ padding: '15px', color: '#999', fontSize: '12px', textAlign: 'center' }}>
              Carregando stories...
            </div>
          )}
          
          {stories.map((story, index) => (
            <div className={styles.storyCard} key={index}>
              {/* NOTA (overlay absoluto, SEM quebrar layout) */}
              <div className={`${styles.storyNote} ${story.isMusicNote ? styles.music : ""}`}>
                {story.isMusicNote ? (
                  <MusicNote music={story.music} />
                ) : (
                  <span className={styles.storyNoteText}>
                    {story.isOwnStory ? "Conte as novidades" : story.note}
                  </span>
                )}
              </div>

              {/* AVATAR */}
              <div className={styles.storyAvatar}>
                <img src={story.avatar} alt={story.name} />
              </div>

              {/* USERNAME */}
              <span className={`${styles.storyUsername} ${story.isOwnStory ? styles.own : ""}`}>
                {story.name}
              </span>
            </div>
          ))}
        </div>

        <div className={styles.storiesGradient} />
      </div>
    </div>
  );
}